import { render, staticRenderFns } from "./FolderAutomationEffect.vue?vue&type=template&id=3b0a4468&scoped=true"
import script from "./FolderAutomationEffect.vue?vue&type=script&lang=js"
export * from "./FolderAutomationEffect.vue?vue&type=script&lang=js"
import style0 from "./FolderAutomationEffect.vue?vue&type=style&index=0&id=3b0a4468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0a4468",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
